import { createSlice } from '@reduxjs/toolkit';

import { inquiryDiscountCode } from 'Feature/Common/Common/Actions/Thunks/inquiryDiscountCode';

import MisDiscountCodeInitialState from './MisDiscountCodeInitialState';

export const misDiscountCodeSlice = createSlice({
  name: 'Common/MisDiscountCode',
  initialState: MisDiscountCodeInitialState,
  reducers: {
    clearInquiryDiscountCodeResult: (state) => {
      state.inquiryDiscountCodeResult = MisDiscountCodeInitialState.inquiryDiscountCodeResult;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(inquiryDiscountCode.pending, (state) => {
        state.inquiryDiscountCodeResult.loading = true;
        state.inquiryDiscountCodeResult.isSuccess = false;
      })
      .addCase(inquiryDiscountCode.fulfilled, (state, action) => {
        state.inquiryDiscountCodeResult.loading = false;
        state.inquiryDiscountCodeResult.data = action.payload;
        if (action.payload !== null && action.payload !== undefined) state.inquiryDiscountCodeResult.isSuccess = true;

        return state;
      })
      .addCase(inquiryDiscountCode.rejected, (state) => {
        state.inquiryDiscountCodeResult.loading = false;
        state.inquiryDiscountCodeResult.isSuccess = false;
      });
  },
});
export const { clearInquiryDiscountCodeResult } = misDiscountCodeSlice.actions;

export default misDiscountCodeSlice.reducer;
